import { ZoomLevelEnum } from '@apps/pata/services/planning/enums';
import { DateTime, Interval } from 'luxon';

abstract class Extremas
{
    /**
     * Données calculées par le front pour être exploitées par les zooms différents de Day/Half day
     */
    /**
     * Premier jour à 0h de la période considérée
     */
    public startingDate: DateTime;
    /**
     * Dernier jour 0h de la période considérée
     */
    public endingDate: DateTime;
    /**
     * Données recalculées , exploitées au niveau zoom Day/Half day
     */
    /**
     * Début de la période en AM ou PM
     */
    public startingTime: DateTime;
    public AMStartingTime: boolean;
    /**
     * Fin de la période en AM ou PM
     */
    public endingTime: DateTime;
    public AMEndingTime: boolean;

    private static AmPmBoundary: number = 14;
    /**
     *
     */
    constructor (startingDate: DateTime, endingDate: DateTime, startingTime: DateTime, endingTime: DateTime)
    {
        this.startingDate = startingDate.startOf('day');
        this.AMStartingTime = startingTime.hour < Extremas.AmPmBoundary;
        this.startingTime = this.AMStartingTime ? startingTime.startOf('day') : startingTime.startOf('day').plus({ hour: Extremas.AmPmBoundary });

        this.endingDate = endingDate.startOf('day');
        this.AMEndingTime = endingTime.hour < Extremas.AmPmBoundary;
        this.endingTime = this.AMEndingTime ? endingTime.startOf('day').plus({ hour: Extremas.AmPmBoundary }) : endingTime.endOf('day');
    }

    public nbFullDaysBefore (beginningOfDate: DateTime): number
    {
        return Interval
            .fromDateTimes(beginningOfDate.startOf('day'), this.startingDate)
            .length('days');
    }

    public nbFullDaysInside (): number
    {
        return Interval
            .fromDateTimes(this.startingDate, this.endingDate.plus({ day: 1 }))
            .length('days');
    }

    public abstract nbPeriodsBefore (beginningOfDate: DateTime, zoomLevel: ZoomLevelEnum): number;

    public abstract nbPeriodsInside (zoomLevel: ZoomLevelEnum): number;
}

export class ProjectExtremas extends Extremas
{
    /**
     *
     */
    constructor (startingDate: DateTime, endingDate: DateTime)
    {
        super(startingDate, endingDate, startingDate, endingDate);
    }

    public nbPeriodsBefore (beginningOfDate: DateTime, zoomLevel: ZoomLevelEnum): number
    {
        if (zoomLevel === ZoomLevelEnum.DayHalfday)
        {
            return this.nbFullDaysBefore(beginningOfDate) * 2;
        }
        else
        {
            return this.nbFullDaysBefore(beginningOfDate);
        }
    }

    public nbPeriodsInside (zoomLevel: ZoomLevelEnum): number
    {
        if (zoomLevel === ZoomLevelEnum.DayHalfday)
        {
            return this.nbFullDaysInside() * 2;
        }
        else
        {
            return this.nbFullDaysInside();
        }
    }
}

export class PhaseExtremas extends Extremas
{
    /**
     *
     */
    constructor (startingTime: DateTime, endingTime: DateTime)
    {
        super(startingTime, endingTime, startingTime, endingTime);
    }

    public nbPeriodsBefore (beginningOfDate: DateTime, zoomLevel: ZoomLevelEnum): number
    {
        if (zoomLevel === ZoomLevelEnum.DayHalfday)
        {
            return (this.nbFullDaysBefore(beginningOfDate) * 2) + (this.AMStartingTime ? 0 : 1);
        }
        else
        {
            return this.nbFullDaysBefore(beginningOfDate);
        }
    }

    public nbPeriodsInside (zoomLevel: ZoomLevelEnum): number
    {
        if (zoomLevel === ZoomLevelEnum.DayHalfday)
        {
            const endingTime = this.AMEndingTime ? this.endingTime.plus({ day: 1 }).startOf('day').minus({ hour: 12 }) : this.endingTime.plus({ day: 1 }).startOf('day');
            const nb: number = Interval
                .fromDateTimes(this.startingTime, endingTime)
                .length('hours');

            return nb / 12;
        }
        else
        {
            return this.nbFullDaysInside();
        }
    }
}

export class PlanifExtremas extends Extremas
{
    public periodOfDay: string;
    /**
     *
     */
    constructor (startingTime: DateTime, endingTime: DateTime)
    {
        super(startingTime, endingTime, startingTime, endingTime);

        if (this.AMStartingTime)
        {
            if (this.AMEndingTime)
            {
                this.periodOfDay = 'MORNING';
            }
            else
            {
                this.periodOfDay = 'DAY';
            }
        }
        else
        {
            this.periodOfDay = 'AFTERNOON';
        }
    }

    public nbPeriodsBefore (beginningOfDate: DateTime, zoomLevel: ZoomLevelEnum): number
    {
        if (zoomLevel === ZoomLevelEnum.DayHalfday)
        {
            return (this.nbFullDaysBefore(beginningOfDate) * 2) + (this.AMStartingTime ? 0 : 1);
        }
        else
        {
            return this.nbFullDaysBefore(beginningOfDate);
        }
    }

    public nbPeriodsInside (zoomLevel: ZoomLevelEnum): number
    {
        if (zoomLevel === ZoomLevelEnum.DayHalfday)
        {
            const endingTime = this.AMEndingTime ? this.endingTime.plus({ day: 1 }).startOf('day').minus({ hour: 12 }) : this.endingTime.plus({ day: 1 }).startOf('day');
            const nb: number = Interval
                .fromDateTimes(this.startingTime, endingTime)
                .length('hours');

            return nb / 12;
        }
        else
        {
            return this.nbFullDaysInside();
        }
    }
}

export class DayExtremas extends Extremas
{
    constructor (day: DateTime)
    {
        super(day, day, day, day);
    }

    public nbPeriodsBefore (beginningOfDate: DateTime, zoomLevel: ZoomLevelEnum): number
    {
        if (zoomLevel === ZoomLevelEnum.DayHalfday)
        {
            return (this.nbFullDaysBefore(beginningOfDate) * 2) + 1;
        }
        else
        {
            return this.nbFullDaysBefore(beginningOfDate) + 0.5;
        }
    }

    public nbPeriodsInside (): number
    {
        return 0;
    }
}
